import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { getSportTypes, resetSportsList } from '../../../store/actions/sportTypes';
import { getFavoriteEvents, getFavoriteLeagues } from '../../../store/actions/favorites';
import { SPORTS_TYPES_DIRECTION } from '../../../constants/defaultValues';
import Placeholder from '../../shared/Sports/Type/Placeholder/Placeholder';
import NavItems from './NavItems';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './SportsNav.module.scss';
import { useLocation } from 'react-router-dom';

const NextArrow = props => {
    const { onClick } = props;
    return <div className={`${styles.nextArrowIcon} icon-arrow-right`} onClick={onClick} />;
};

const PrevArrow = props => {
    const { onClick } = props;
    return <div className={`${styles.prevArrowIcon} icon-arrow-left`} onClick={onClick} />;
};

const getSettings = isESports => ({
    dots: false,
    infinite: !isESports,
    speed: 500,
    useTransform: false,
    swipeToSlide: !isESports,
    variableWidth: true,
    initialSlide: 0,
    nextArrow: isESports ? null : <NextArrow />,
    prevArrow: isESports ? null : <PrevArrow />,
});

const LiveSports = () => {
    const dispatch = useDispatch();

    const { fetching } = useSelector(state => state.sportTypes);
    const { eventType } = useSelector(state => state.sportEvents);

    const location = useLocation();

    const isEsportPage = useMemo(() => {
        return location.pathname.includes("e-sports") || location.pathname.includes("e-live");
    }, [location.pathname]);

    const [mouseDown, setMouseDown] = useState({
        x: null,
        y: null,
    });

    const onMouseDown = e => {
        setMouseDown({
            x: e.clientX,
            y: e.clientY,
        });
        e.preventDefault(); // stops weird link dragging effect
    };

    const onSportClick = e => {
        e.stopPropagation();
        if (
            Math.floor(mouseDown.x) !== Math.floor(e.clientX) ||
            Math.floor(mouseDown.y) !== Math.floor(e.clientY)
        ) {
            // prevent link click if the element was dragged
            e.preventDefault();
        }
    };

    useEffect(() => {
        if (isEsportPage !== null){
            dispatch(getSportTypes({ isLive: true, eventType: eventType.value, eSport: isEsportPage }));
        }
        dispatch(getFavoriteEvents());
        dispatch(getFavoriteLeagues());

        return () => {
            dispatch(resetSportsList());
        };
    }, [isEsportPage]);

    return (
        <>
            <nav
                className={classnames(styles.liveNav, {
                    [styles.isESports]: isEsportPage,
                })}
            >
                <ul className={styles.menu}>
                    {fetching ? (
                        <Placeholder count={20} direction={SPORTS_TYPES_DIRECTION.horizontal} />
                    ) : (
                        <NavItems
                            onMouseDown={onMouseDown}
                            onSportClick={onSportClick}
                            sliderSettings={getSettings(isEsportPage)}
                        />
                    )}
                </ul>
            </nav>
        </>
    );
};

export default LiveSports;
